import DataTable from 'datatables.net-react';
import { useEffect, useState } from 'react';
import { Container, Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import ReactDOMServer from 'react-dom/server';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import Swal from 'sweetalert2'; // Import SweetAlert2
import { CustomerServices } from '../../services/CustomerServices';
import { ResetPasswordService } from '../../services/ResetPasswordService';
import * as BullCache from "../../util/BullCache";
import AdminDropdown from '../components/AdminDropdown';
import BrokerDropdown from '../components/BrokerDropdown';
import { customStyles } from '../components/customStyles';
import From from '../components/From';
import MasterDropdown from '../components/MasterDropdown';
import SubBrokerDropdown from '../components/SubBrokerDropdown';
import To from '../components/To';
import "../custom.css";
import { FaDownload } from 'react-icons/fa';


function Customer() {

  const [loading, setLoading] = useState(false);
  const [master, setMaster] = useState([]);
  const [broker, setBroker] = useState([]);
  const [client, setclient] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedBrokerId, setSelectedBrokerId] = useState(null);
  const [selectedSubBrokerId, setSelectedSubBrokerId] = useState(null);
  const [userlist, setUserlist] = useState([]);
  const [selectedMaster, setSelectedMaster] = useState(null);
  const [selectedBroker, setSelectedBroker] = useState(null);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [selectedSubBroker, setSelectedSubBroker] = useState(null);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [transactionList, setTransactionList] = useState(null);
  const [rowId, SetRowId] = useState(null);
  const [dataId, SetDataId] = useState(null);

  const navigate = useNavigate();

  var user = BullCache.getFromCache("user");
  useEffect(() => {
    CustomerServices.getAll({ 'adminId': user.adminId }).then(res => {

      if (res.code === 1 && res.data) {
        if (res.data.masterList && res.data.masterList.length > 0) {
          setMaster(res.data.masterList);
        }
        if (res.data.brokerList && res.data.brokerList.length > 0) {
          setBroker(res.data.brokerList);
        }
      }
    });
    
    getCustomers();

  }, []);

  function getCustomers() {
    var subBroker1 = {};
    setLoading(true);

    if (!selectedAdmin && !selectedMaster && !selectedBrokerId && !selectedSubBrokerId) {
        subBroker1 = {adminId: user.adminId };
    } else {
      if (selectedSubBrokerId) {
        subBroker1.adminId = selectedSubBrokerId.value;
      } else if (selectedBrokerId) {
        subBroker1.adminId = selectedBrokerId;
      } else if (selectedMaster) {
        subBroker1.adminId = selectedMaster.value;
      } else if (selectedAdmin) {
        subBroker1.adminId = selectedAdmin.value;
      }
    }
    setUserlist([]);
    CustomerServices.getUserdata(subBroker1).then(resp => {
      setLoading(false);
      if (resp.code === 1 && resp.data) {
        if (resp.data.userList && resp.data.userList.length > 0) {
          setUserlist(resp.data.userList);
        } 
      }
    });

  }

  const handleSubmit = () => {
     getCustomers();
  };

  const handleSelectedMasterChange = (selectedOption) => {
    setSelectedMaster(selectedOption);
  };

  const handleSelectedBrokerChange = (selectedOption) => {
    setSelectedBroker(selectedOption);
  };
  const handleSelectedAdminChange = (selectedOption) => {
    setSelectedAdmin(selectedOption);
  };

  const handleSelectedSubBrokerChange = (selectedOption) => {
    setSelectedSubBroker(selectedOption);
  };

  const handleFromDateChange = (newDate) => {
    setFromDate(newDate);
  };

  const handleToDateChange = (newDate) => {
    setToDate(newDate);
  };

  document.addEventListener("click", (e) => {
    if (e.target.closest("button[data-user-id]")) {
      const valanId = e.target.closest("button[data-valan-id]").dataset.valanId;
      const userId = e.target.closest("button[data-user-id]").dataset.userId;
      downloadPDF(valanId, userId);
    }
  });

  const downloadPDF = (valanId, userId) => {
       navigate("/usersummary", { state: { userId: userId, valan: valanId} });  
    };

  const handleLedger = (event) => {
    const dataId = event.target.getAttribute("data-id");

    setShowModal(true);
    const selectedUserData = userlist.find(user => user.userid === dataId);
    if (selectedUserData) {
      setSelectedUser(`${selectedUserData.firstName} (${selectedUserData.userName})`);

    }

    CustomerServices.getAccount({ 'userId': dataId }).then(resp => {
      if (resp.code === 1) {
        const transactionList = resp.data.account.transactionList;

        const mappedTransactions = transactionList.map((transaction, index) => {
          return {
            srNo: index + 1,
            name: transaction.valan,
            date: transaction.date,
            debit: transaction.amount < 0 ? transaction.amount : '',
            credit: transaction.amount > 0 ? transaction.amount : '',
            balance: transaction.balance,
            download:  transaction.billEntry ? `<button class="btn btn-outline-success btn-sm ms-1 mt-0 pt-0 pb-0 text-center"
                                                data-valan-id="${transaction.valanId}"
                                                data-user-id="${dataId}">
                                                <i class="fa fa-download"></i>
                                                </button>`
                                                : "",
          };
        });
        setTransactionList(mappedTransactions);
      }
    });
  };
  const handleClick = (event) => {
    if (event.target.classList.contains("bg-danger")) {
      handleLedger(event);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };

  }, [userlist]);

  const handleNavigate = (event) => {
    const rowId = event.target.getAttribute("row-id");
    const dataId = event.target.getAttribute("data-id");
    
    navigate("/editAccount", { state: { rowId, userId: dataId } });

  };
  const handlePasswordReset = (dataId) => {
    // Call the API to reset the password
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to reset the password for this user.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, reset it!",
      cancelButtonText: "No, cancel"
    }).then((result) => {
      if (result.isConfirmed) {
        const resetPayload = {
          userId: dataId,
          loginId: user.adminId // Include loginId along with adminId in the request
        };
        // If user clicks "Yes", proceed with password reset
        ResetPasswordService.resetPassword(resetPayload).then(resp => {
          if (resp.code === 1) {

            const userName = resp.data.userName;
            const password = resp.data.password;
            Swal.fire({
              title: "Success!",
              html: `Password reset successfully.<br> UserName: <b> ${userName} </b> <br> Password: <b> ${password} </b>`,
              icon: "success",
              confirmButtonText: "Okay",
            });
          
          } else {
            Swal.fire({
              title: "Error",
              text: resp.messages,
              icon: "error"
            });
          }
        }).catch((error) => {
          Swal.fire({
            title: "Error",
            text:  error?.response?.data?.data?.errors[0]?.errorMessage || "Netwrok error!",
            icon: "error"
          });
        });
      }
    });
  };

  const handleClickNavigate = (event) => {
    if (event.target.classList.contains("table-btn")) {
        const buttonType = event.target.textContent.trim();
        const dataId = event.target.getAttribute("data-id");

        if (buttonType === "RP") {
          const adminUserName = event.target.getAttribute("admin-userName");
          if(adminUserName == undefined || adminUserName === user.userName || user.adminType === 'SUPER_ADMIN'){
            handlePasswordReset(dataId);
          } else {
            // If user clicks "No", do nothing
            Swal.fire({
              title: "Error",
              text: "Access Denied!",
              icon: "error"
            });
          }
        }
        else if (buttonType === "A") {
            handleUserStatusChange(dataId, "DEACTIVE"); 
        }
        else if (buttonType === "D") {
            handleUserStatusChange(dataId, "ACTIVE"); 
        }
        else if (buttonType === "ROP") {
            handleReopenPosition(dataId);
        } else {
            handleNavigate(event);
        }
    }
};
  useEffect(() => {
    document.addEventListener("click", handleClickNavigate);

    return () => {
      document.removeEventListener("click", handleClickNavigate);
    };
  }, []);

    const handleUserStatusChange = (dataId, status) => {
               const action = status === "ACTIVE" ? "Activate" : "Deactivate";
               Swal.fire({
                   title: `Are you sure?`,
                   text: `You are about to ${action} this user.`,
                   icon: "warning",
                   showCancelButton: true,
                   confirmButtonText: `Yes, ${action} it!`,
                   cancelButtonText: "No, cancel"
               }).then((result) => {
                   if (result.isConfirmed) {
                       const statusPayload = {
                           userId: dataId,
                           loginId: user.adminId,  // Include loginId along with adminId in the request
                           status: status
                       };
           
                       CustomerServices.changeStatus(statusPayload).then(resp => {
                           if (resp.code === 1) {
                               Swal.fire({
                                   title: "Success",
                                   text: `User ${action}d successfully!`,
                                   icon: "success"
                               });
                               getCustomers();
                           } else {
                               Swal.fire({
                                   title: "Error",
                                   text: resp.messages,
                                   icon: "error"
                               });
                           }
                       }).catch((error) => {
                           Swal.fire({
                               title: "Error",
                               text:  error?.response?.data?.data?.errors[0]?.errorMessage || "Netwrok error!",
                               icon: "error"
                           });
                       });
                   } 
               });
           };

  const handleReopenPosition = (dataId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to reopen positions for this user.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No"
    }).then((result) => {
      if (result.isConfirmed) {
        CustomerServices.freshLimit({
          loginId: user.adminId,
          userId: dataId
        }).then(resp => {
          if (resp.code === 1) {
            Swal.fire({
              title: "Success",
              text: resp.messages || "Positions reopened successfully!",
              icon: "success"
            });
            getCustomers();
          } else {
            Swal.fire({
              title: "Error",
              text: resp.messages || "Failed to reopen positions!",
              icon: "error"
            });
          }
        }).catch((error) => {
          Swal.fire({
            title: "Error",
            text: error?.response?.data?.data?.errors[0]?.errorMessage || "Netwrok error!",
            icon: "error"
          });
        });
      }
    });
  };

  const columns = [
    {
      title: 'NAME', className: 'col-2 font-bold text-nowrap fss-09', render: (data, type, full, meta) => {
        return full.firstName
      }
    },
    { title: 'LOGIN ID', data: 'userName', className: 'col-1 font-bold fss-09' },
    { title: 'BROKER', render: (data, type, full, meta) => (full.subBrokerId ? full.subBrokerId.firstName + (full.subBrokerId2 ? ', ' : '') : '')  + ' '+ (full.subBrokerId2 ? full.subBrokerId2.firstName : '') , className: 'col-1 font-bold fss-09' },
    { title: 'MASTER', render: (data, type, full, meta) => full.admin?.adminType === 'MASTER' ? full.admin.firstName : '', className: 'col-1 font-bold fss-09' },
    {
      title: 'ACTION', data: 'status', className: 'col-2 font-bold text-center text-nowrap fss-09',
      render: (data, type, row, full, meta) => {

        if(user.adminType === 'SUBBROKER') {
          return `
          <button title="Ledger" class=" font-bold fss-1 bg-danger btn-table "  row-id="${full.row}" data-id="${row.userid}" >L</button>
          `;
        } else {
          return `
          <button title="Edit Settings" class="table-btn font-bold fss-1 bg-warning btn-table" row-id="${full.row}" data-id="${row.userid}" >E</button>
          <button title="Ledger" class=" font-bold fss-1 bg-danger btn-table "  row-id="${full.row}" data-id="${row.userid}" >L</button>
          <button title="Reset Password" class="table-btn font-bold fss-1 bg-success btn-table" admin-userName="${row.admin.userName}" row-id="${full.row}" data-id="${row.userid}">RP</button>
          <button class="font-bold fss-1 table-btn btn-table ${row.status ? 'bg-primary' : 'bg-secondary'}" row-id="${full.row}" data-id="${row.userid}" title="${row.status ? 'Active' : 'DeActive'}">
          ${row.status ? 'A' : 'D'}
          </button>
          ${user.adminType === 'SUPER_ADMIN' ? `<button title="Reopen Position" class="table-btn font-bold fss-1 bg-info btn-table" style="width: auto; min-width: 42px;" row-id="${full.row}" data-id="${row.userid}">ROP</button>` : ''}`;
        }
      },
    },

    { title: 'LOGIN TIME', className: 'font-bold text-nowrap fss-09', render: (data, type, full, meta) => full.lastLogin?? '' },
    {
      title: 'LOGIN IP', className: 'col-1 font-bold text-nowrap fss-09', render: (data, type, full, meta) => {
        if (full.loginIp != undefined) {
          return ReactDOMServer.renderToString(<a href={`https://whatismyipaddress.com/ip/${full.loginIp}`} target='_blank'>{full.loginIp}</a>)
        } else {
          return '';
        }
      }
    },
    { title: 'JOIN TIME', data: 'subscriptionDate', className: 'col-1 font-bold fss-09' },

  ];

  const modalColumns = [
    {
      title: 'SR NO',
      className: 'col-1 ledger bg-body font-bold fss-1',
      render: (data, type, full, meta) => meta.row + 1
    },
    { title: 'NAME', data: 'name', className: 'col-1 ledger bg-body font-bold fss-1' },
    { title: 'DATE', data: 'date', className: 'col-1 ledger bg-body font-bold fss-1' },
    { title: 'DEBIT', data: 'debit', className: 'col-1 ledger bg-body font-bold fss-1' },
    { title: 'CREDIT', data: 'credit', className: 'col-1 ledger bg-body font-bold fss-1' },
    { title: 'BALANCE', data: 'balance', className: 'col-1 ledger bg-body font-bold fss-1' },
    { title: 'DOWNLOAD', data: 'download', className: 'col-1 ledger bg-body font-bold fss-1' },
  ];


  return (
    <div className='container-fluid mb-5'>
      <Card className='mt-1'>
        <Card.Body>
          <Container fluid>
            <Row >

              {user.adminType == 'SUPER_ADMIN' || user.adminType == 'SUPER_MASTER' ?
                <>
                  <Col xs={6} sm={2}>
                    <b className="fss-05">ADMIN</b>
                    <AdminDropdown
                      adminId={user.adminId}
                      selectedAdmin={selectedAdmin}
                      setSelectedOption={setSelectedAdmin}
                       />
                  </Col>
                </> : ""}

              {user.adminType == 'SUPER_ADMIN' || user.adminType == 'ADMIN' || user.adminType == 'SUPER_MASTER' ?
                <>
                  <Col xs={6} sm={2}>
                    <b className="fss-05">MASTER</b>
                    <MasterDropdown
                      adminId={user.adminId}
                      selectedAdmin={selectedAdmin}
                      selectedMaster={selectedMaster}
                      setSelectedOption={setSelectedMaster}
                      setSelectedMaster={setSelectedMaster}
                      setSelectedBrokerId={setSelectedBrokerId}
                    />
                  </Col>
                </> : ""}

            

              {user.adminType == 'SUPER_ADMIN' || user.adminType == 'ADMIN' || user.adminType == 'MASTER' || user.adminType == 'BROKER' 
              || user.adminType == 'SUPER_MASTER' ?
                <>
                  <Col xs={6} sm={2}>
                    <b className="fss-05">BROKER</b>
                    <SubBrokerDropdown
                      selectedAdmin={selectedAdmin}
                      selectedMaster={selectedMaster}
                      selectedBrokerId={selectedBrokerId}
                      setSelectedOption={setSelectedSubBrokerId}
                      setSelectedSubBrokerId={setSelectedSubBrokerId}
                    />
                  </Col>
                </> : ""}

              <Col xs={6} sm={2} xl={1} className='me-1'>
                <b className='fss-05'>FROM</b><br />
                <From fromDate={fromDate} onDateChange={handleFromDateChange} />
              </Col>
              <Col xs={5} sm={2} className=''>
                <b className='fss-05'>TO</b><br />
                <To toDate={toDate} setToDate={setToDate} />
              </Col>

              <Col xs={5} sm={2} className="mt-4">
                <Button variant="success" size="sm w-75" onClick={handleSubmit}>
                  <b className="fss-08" >SUBMIT</b>
                </Button>
              </Col>

              <Col></Col>

            </Row>


          </Container>
        </Card.Body>
      </Card>

      <Card className='mt-1 ' >
        <Card.Body className='ps-0 pe-0'>
        <div className="table-responsive">
            {loading ? (
              <div className="container vh-100">
                <div className="d-flex align-items-center justify-content-center h-90">
                  <div className="spinner-border text-secondary m-5" role="status" style={{ width: '4rem', height: '4rem' }}>
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              </div>
            ) : 
              <DataTable id="table" className="mt-1 table table-striped bg-secondary-row fss-09"
                data={userlist} columns={columns}
              />
            }
          </div>

        </Card.Body>
      </Card>

      <Modal show={showModal} onHide={() => setShowModal(false)} size="xl">
        <Modal.Header closeButton>
          <Col>
            <Modal.Title className='h6'> LEDGER </Modal.Title>
          </Col>
          <Col>
            <label className='text-center h6'> {selectedUser} </label>
          </Col>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className='col-2' xs={6}>
              <label className='fss-05 h6'> FROM DATE </label> <br />
              <Form.Control type='date' size='sm' className=' bg-light text-black rounded-input ' onDateChange={handleFromDateChange} />
            </Col>
            <Col className='col-2'>
              <label className='fss-05 h6'> ENTRY TYPE </label> <br />
              <Select
                options={[
                  { value: '', label: 'Both' },
                  { value: '', label: 'Cash Entry' },
                  { value: '', label: 'Bill Entry' }
                ]}
                className='text-black'
                styles={customStyles}
                placeholder="Select"
                isClearable
              />
            </Col>
            <Col className='col-2 mt-4'>
              <Button size='sm' variant='warning' className='text-light'>Find Logs</Button>
            </Col>

          </Row>
          <Row className='mt-2 ledger bg-body '>
            <div className="table-responsive">

              <DataTable
                id="popup-table"
                className="table  bg-head-secondary fss-09 white-bordered-table "
                columns={modalColumns}
                data={transactionList}
              />
            </div>
          </Row>
        </Modal.Body>

      </Modal>


    </div>
  )

}

export default Customer;